import { render, staticRenderFns } from "./task_tabs_result.vue?vue&type=template&id=6d42ed0d&scoped=true&"
import script from "./task_tabs_result.vue?vue&type=script&lang=js&"
export * from "./task_tabs_result.vue?vue&type=script&lang=js&"
import style0 from "./task_tabs_result.vue?vue&type=style&index=0&id=6d42ed0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d42ed0d",
  null
  
)

export default component.exports